import { useMutation, useQuery } from "@apollo/client";
import { useMemo } from "react";
import { gql } from "./types";

const GET_AUTHENTICATION_POLICY = gql(/* GraphQL */ `
  query GetAuthenticationPolicy {
    findEnvironmentFeatures {
      google_sign_in_feature
    }
  }
`);

const UPDATE_AUTHENTICATION_POLICY = gql(/* GraphQL */ `
  mutation UpdateAuthenticationPolicy($features: FeaturesConfigInput!) {
    upsertEnvironmentFeatures(features: $features) {
      google_sign_in_feature
    }
  }
`);

type AuthenticationPolicyInput = {
  googleSignInEnabled?: boolean | null;
};

export const useAuthenticationPolicy = () => {
  const { data, loading, error, refetch } = useQuery(GET_AUTHENTICATION_POLICY);
  const [updateAuthenticationPolicy, { loading: updating }] = useMutation(
    UPDATE_AUTHENTICATION_POLICY,
  );
  const saveAuthenticationPolicy = async (input: AuthenticationPolicyInput) => {
    await updateAuthenticationPolicy({
      variables: {
        features: {
          google_sign_in_feature: input.googleSignInEnabled,
        },
      },
    });
    await refetch();
  };
  const authenticationPolicy = useMemo(
    () => ({
      googleSignInEnabled:
        data?.findEnvironmentFeatures?.google_sign_in_feature ?? true,
    }),
    [data?.findEnvironmentFeatures?.google_sign_in_feature],
  );
  return {
    authenticationPolicy,
    loading,
    error,
    saveAuthenticationPolicy,
    updating,
  };
};
